// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientQuestionnaire_root__12VZU","header":"PatientQuestionnaire_header__2cNb4","info":"PatientQuestionnaire_info__15EBI"};